import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'upgrade-plan',
  children: {
    customBundles: {
      path: 'custom',
    },
    success: {
      path: 'success',
    },
    error: {
      path: 'error',
    },
    payment: {
      path: 'payment',
    },
    upgrade: {
      path: 'upgrade',
    },
    contactSales: {
      path: 'contact-sales',
    },
    checkout: {
      path: 'checkout',
    },
  },
} as const satisfies Location
